/* eslint-disable camelcase */
import { instanceApi, instanceOEF, segundaVersaoOEF } from './api'
import { formatDataNascimento, normalizeNumberString } from '../utils/formatter/formatter'

export const getDadosAssociado = () => instanceOEF.get( `${segundaVersaoOEF}/associado` )

export const getCategoriasDoAssociado = () => instanceApi.get( '/v1/associado/categorias' )

export const patchDadosAssociado = dadosAssociado => {
  const { dtNascimento, cpf, email, nome, sexo, sobrenome, 'telefone': rawTelefone, senha, porque_assinou } = dadosAssociado

  const payload = {
    'associado': {
      cpf,
      'dt_nascimento': formatDataNascimento( dtNascimento, '/', '-' ),
      email,
      nome,
      senha,
      sexo,
      sobrenome,
      porque_assinou,
    }
  }

  if ( rawTelefone ) {
    payload.associado.telefone = normalizeNumberString( rawTelefone )
  }

  return instanceOEF.patch( `${segundaVersaoOEF}/associado`, payload )
}
